import * as moment from 'moment';

export default class DateUtils {

  static validDateFormats = ['YYYY', 'YYYY-MM', 'YYYY-MM-DD'];

  static parseDateFormat(date: string): string {
    let format = this.validDateFormats.find(dateFormat => moment(date, dateFormat, true).isValid());

    if (format) {
      format = format.replace(/Y/g, 'y');
      format = format.replace(/D/g, 'd');
    }
    return format;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/shared/date-utils.ts